module.exports = __webpack_public_path__ + "static/media/GaldisaJapanesePeanut.1a05e7e0.pdf";